/**
 * ProfileIcon - Minimal profile display in top-right corner
 * Shows user avatar when logged in, login button when not
 */
import React, { useState } from 'react';
import './ProfileIcon.css';
import { useAuth } from '../contexts/AuthContext';

const ProfileIcon = () => {
    const { user, isAuthenticated, logout } = useAuth();
    const [showDropdown, setShowDropdown] = useState(false);

    // Show login button if not authenticated
    if (!isAuthenticated || !user) {
        const handleLogin = () => {
            window.location.href = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/auth/google`;
        };

        return (
            <button className="btn btn-secondary login-button" onClick={handleLogin}>
                Sign in
            </button>
        );
    }

    const handleLogout = async () => {
        await logout();
        setShowDropdown(false);
    };

    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        }
        return name[0].toUpperCase();
    };

    return (
        <div className="profile-icon-container">
            <button
                className="profile-icon-button"
                onClick={() => setShowDropdown(!showDropdown)}
                title={user.name || user.email}
            >
                {user.picture ? (
                    <img src={user.picture} alt={user.name || 'User'} className="profile-avatar" />
                ) : (
                    <div className="profile-initials">{getInitials(user.name || user.email)}</div>
                )}
            </button>

            {showDropdown && (
                <>
                    <div className="profile-dropdown-overlay" onClick={() => setShowDropdown(false)} />
                    <div className="profile-dropdown">
                        <div className="profile-dropdown-header">
                            <div className="profile-dropdown-name">{user.name || 'User'}</div>
                            <div className="profile-dropdown-email">{user.email}</div>
                            {user.designs_count > 0 && (
                                <div className="profile-dropdown-stats">
                                    {user.designs_count} design{user.designs_count !== 1 ? 's' : ''}
                                </div>
                            )}
                        </div>
                        <div className="profile-dropdown-divider" />
                        <button className="profile-dropdown-logout" onClick={handleLogout}>
                            Sign out
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default ProfileIcon;
